import qs from 'qs';

import envBaseUrl from 'src/components/pipelines/utils/env-base-url';

import { MergeQueueState } from './types';

export const MERGE_QUEUE_ACTION_EVENT_MAP: Record<MergeQueueState, string> = {
  [MergeQueueState.ACTIVE]: 'activateMergeQueue',
  [MergeQueueState.DRAINING]: 'drainMergeQueue',
  [MergeQueueState.INACTIVE]: 'deactivateMergeQueue',
};

export type MergeQueuesUrlOptions = {
  branchName?: string;
  branchType?: string;
  branchPattern?: string;
  name?: string;
  page?: string;
  pagelen?: string;
};

export type MergeQueuePullRequestsUrlOptions = {
  page?: string;
  pagelen?: string;
};

export const getMergeQueuesUrl = (
  repositoryOwner: string,
  repositorySlug: string,
  options?: MergeQueuesUrlOptions
) => {
  const url = `${envBaseUrl(
    '/!api/internal'
  )}/repositories/${repositoryOwner}/${repositorySlug}/merge-queues/configs`;

  if (options) {
    return `${url}${qs.stringify(options, {
      skipNulls: true,
      addQueryPrefix: true,
    })}`;
  }

  return url;
};

export const getMergeQueuePullRequestsUrl = (
  repositoryOwner: string,
  repositorySlug: string,
  mergeQueueUuid: string,
  options?: MergeQueuePullRequestsUrlOptions
) => {
  const url = `${getMergeQueuesUrl(
    repositoryOwner,
    repositorySlug
  )}/${mergeQueueUuid}/pullrequests`;

  if (options) {
    return `${url}${qs.stringify(options, {
      skipNulls: true,
      addQueryPrefix: true,
    })}`;
  }

  return url;
};
